var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 81,
    viewBox: "0 0 208 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.933 62.3651H83.916L90.8068 19.772H101.823L94.933 62.3651Z",
    fill: "#00579F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.871 20.8134C132.698 19.9515 129.251 19 124.989 19C114.11 19 106.448 24.7996 106.401 33.0913C106.311 39.2089 111.887 42.6068 116.057 44.6466C120.319 46.731 121.768 48.0914 121.768 49.9494C121.725 52.8028 118.324 54.1181 115.152 54.1181C110.753 54.1181 108.397 53.44 104.815 51.8525L103.364 51.1719L101.823 60.7332C104.407 61.91 109.167 62.9542 114.11 63C125.669 63 133.195 57.2901 133.284 48.454C133.328 43.6053 130.384 39.8901 124.037 36.8542C120.184 34.9053 117.824 33.5912 117.824 31.5972C117.869 29.7844 119.82 27.9277 124.169 27.9277C127.751 27.8367 130.382 28.6973 132.376 29.5586L133.372 30.0108L134.871 20.8134Z",
    fill: "#00579F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.512 47.2759C150.42 44.829 153.911 35.3587 153.911 35.3587C153.865 35.4496 154.816 32.8666 155.36 31.2809L156.13 34.951C156.13 34.951 158.216 45.1464 158.67 47.2759C156.948 47.2759 151.688 47.2759 149.512 47.2759ZM163.111 19.772H154.59C151.962 19.772 149.965 20.5416 148.832 23.3059L132.467 62.3645H144.027C144.027 62.3645 145.93 57.1075 146.339 55.9753C147.607 55.9753 158.853 55.9753 160.484 55.9753C160.8 57.4707 161.799 62.3645 161.799 62.3645H171.999L163.111 19.772Z",
    fill: "#00579F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7145 19.772L63.9253 48.8164L62.7463 42.9259C60.7516 36.1289 54.4958 28.7442 47.5146 25.0723L57.3972 62.32H69.0473L86.3641 19.772H74.7145Z",
    fill: "#00579F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9065 19.772H36.1813L36 20.6326C49.8268 24.1672 58.984 32.6871 62.7462 42.9277L58.893 23.3523C58.2586 20.632 56.3091 19.8617 53.9065 19.772Z",
    fill: "#FAA61A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 44,
    fill: "white",
    transform: "translate(36 19)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.9f72251c.svg";
export { ForwardRef as ReactComponent };